// extracted by mini-css-extract-plugin
module.exports = {"header":"product-layout-module--header--3pGg3","footer":"product-layout-module--footer--3KKPr"};